import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { useSelector, useDispatch } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import {
  addNewAmenities,
  viewAmenity,
} from "../../Redux/Actions/amenitiesResaleActions";
import toast from "react-hot-toast";
import { viewSubCategoryList } from "../../Redux/Actions/categoryActions";
import "./addSubAmenities.css";

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const AddSubAmenities = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { amenity } = useSelector((state) => state.amenitiesResale || {});
  const { subCategories } = useSelector((state) => state.categories || {});

  const [loading, setLoading] = useState(false);
  const [amenityData, setAmenityData] = useState({
    amenityName: "",
    position: Math.floor(Math.random() * 1000) + 1,
    amenitiesFor: "",
    image: "",
    parent: id,
    category: "",
    business_type: [],
  });

  useEffect(() => {
    dispatch(viewAmenity(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (amenity?.data) {
      const payload = { page: 1, limit: 1000, category_id: amenity?.data?.project_type?._id };
      console.log("day", payload)
      dispatch(viewSubCategoryList(payload));
    }
    if (amenity?.data) {
      setAmenityData((prev) => ({
        ...prev,
        amenitiesFor: amenity.data.amenities_for || ''
      }));
    }
  }, [amenity?.data, dispatch]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const imageUrl = await AddImage(file);
    if (imageUrl) {
      setAmenityData((prev) => ({ ...prev, image: imageUrl }));
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setAmenityData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!amenityData.amenityName?.trim()) return toast.error("Sub amenity name is required");

    setLoading(true);
    const filteredPayload = Object.fromEntries(
      Object.entries(amenityData).filter(([_, v]) => v !== null && v !== undefined && v !== "")
    );
    try {
      const response = await dispatch(addNewAmenities(filteredPayload));
      if (response?.statusCode === 200) {
        navigate(`/amenities/view/${id}`);
      } else {
        toast.error(response?.message || "Failed to add sub amenity");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="asb-wrapper">
        <div className="asb-header">
          <div className="asb-header-left">
            <div className="asb-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            </div>
            <div>
              <h1 className="asb-title">{amenity?.data?.name || "Add Sub Amenity"}</h1>
              <p className="asb-subtitle">Add a sub amenity under the selected parent</p>
            </div>
          </div>
          <button type="button" onClick={() => navigate(-1)} className="asb-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
            View Sub-Amenities List
          </button>
        </div>

        <form className="asb-form" onSubmit={handleSubmit}>
          <div className="asb-section">
            <div className="asb-section-header">
              <span className="asb-section-badge">01</span>
              <h2 className="asb-section-title">Details & Icon</h2>
            </div>

            <div className="asb-grid asb-grid-2">
              <div className="asb-field">
                <label className="asb-label">Amenity For</label>
                <input
                  className="asb-input asb-input--readonly"
                  type="text"
                  value={amenity?.data ? amenity.data.amenities_for : "No Data"}
                  disabled
                />
              </div>

              <div className="ab-field" asb-grid-2>
                <label className="ab-label">Business Type <span className="ab-optional">(Optional)</span></label>
                <div className="ab-checkbox-group">
                  {["fresh", "resale", "business", "rental"].map((type) => (
                    <label key={type} className="ab-checkbox-label">
                      <input
                        type="checkbox"
                        value={type}
                        checked={amenityData.business_type.includes(type)}
                        onChange={(e) => {
                          const { value, checked } = e.target;
                          setAmenityData((prev) => ({
                            ...prev,
                            business_type: checked
                              ? [...prev.business_type, value]
                              : prev.business_type.filter((t) => t !== value),
                          }));
                        }}
                        disabled={loading}
                      />
                      {type.charAt(0).toUpperCase() + type.slice(1)}
                    </label>
                  ))}
                </div>
              </div>

              <div className="asb-field">
                <label className="asb-label">Sub Amenity Name <span className="asb-req">*</span></label>
                <input
                  className="asb-input"
                  type="text"
                  name="amenityName"
                  value={amenityData.amenityName}
                  onChange={handleChange}
                  placeholder="e.g. Indoor Pool"
                  disabled={loading}
                />
              </div>

              <div className="asb-field">
                <label className="asb-label">Select Category <span className="asb-optional">(Optional)</span></label>
                <select
                  className="asb-select"
                  name="category"
                  value={amenityData.category}
                  onChange={handleChange}
                  disabled={loading}
                >
                  <option value="">Select an option</option>
                  {Array.isArray(subCategories?.data) &&
                    subCategories.data.map((sub) => (
                      <option key={sub._id} value={sub._id}>{sub.name}</option>
                    ))}
                </select>
              </div>

              <div className="asb-field asb-field--full">
                <label className="asb-label">Sub Amenity Icon <span className="asb-req">*</span></label>
                {amenityData.image ? (
                  <div className="asb-image-preview">
                    <img src={amenityData.image} alt="Sub amenity icon" className="asb-preview-img" />
                    <div className="asb-preview-info">
                      <span className="asb-preview-label">Icon uploaded</span>
                      <button
                        type="button"
                        className="asb-remove-btn"
                        onClick={() => setAmenityData((prev) => ({ ...prev, image: "" }))}
                        disabled={loading}
                      >
                        <TrashIcon />
                        Remove
                      </button>
                    </div>
                  </div>
                ) : (
                  <label className="asb-upload-zone" htmlFor="sub-amenity-image">
                    <input
                      id="sub-amenity-image"
                      type="file"
                      name="image"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      disabled={loading}
                    />
                    <div className="asb-upload-icon">
                      <UploadIcon />
                    </div>
                    <span className="asb-upload-text">Click to upload icon</span>
                    <span className="asb-upload-hint">PNG, JPG, SVG up to 2MB</span>
                  </label>
                )}
              </div>
            </div>
          </div>

          <div className="asb-footer">
            <div className="asb-footer-nav">
              <button type="submit" className="asb-btn asb-btn--submit" disabled={loading}>
                {loading ? (
                  "Saving..."
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Save Sub Amenity
                  </>
                )}
              </button>
            </div>
            <Link to="/amenities" className="asb-btn asb-btn--cancel">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddSubAmenities;